import type { ComponentStyleConfig } from '@chakra-ui/react';

const Link: ComponentStyleConfig = {
  baseStyle: {
    color: 'admin.blue.700',
    fontSize: '15px',
    fontWeight: 400,
    _focus: {
      boxShadow: 'none',
    },
    _hover: {
      textDecoration: 'none',
    },
  },
};

export default Link;
